/**
 * 富文本处理
 *
 * 后台产品/方案的介绍用富文本编辑器保存，字段里带 <p></p>、<br> 等标签。
 * 前台直接渲染（{product.description}）会把标签当普通文字显示出来，
 * 这里统一转成纯文本。
 */

export function stripHtml(html) {
  if (html === null || html === undefined) return '';
  return String(html)
    .replace(/<(script|style)[\s\S]*?<\/\1>/gi, '')
    .replace(/<br\s*\/?\s*>/gi, '\n')
    .replace(/<\/(p|div|li|h[1-6]|tr|blockquote)>/gi, '\n')
    .replace(/<li[^>]*>/gi, '• ')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

export default stripHtml;
